import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {ProjectTeamMember} from '@/features/projects/types'
import {teamGroupToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'

export const MedicalReportMrpCard = ({referringDoctor}: {referringDoctor: ProjectTeamMember}) => {
    const {t} = useTranslation()

    return (
        <FormCardSection columns={1} gap={2} padding={3} fullWidth>
            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t(teamGroupToLabel[referringDoctor.group])} - {referringDoctor.specializationName}
                </Text>
                <Text weight="500" palette="neutral" shade="950" size="textSm">
                    {referringDoctor.fullName}
                </Text>
            </GridItem>
        </FormCardSection>
    )
}
